import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material//dialog';
import { Subscription } from 'rxjs';
import { BackEndService } from 'src/app/backend-service';
import { Notification, PaginationPage, PaginationResponse } from 'src/app/classes';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.css']
})
export class NotificationDialogComponent implements OnDestroy, OnInit {

  total: number = 0;
  unseenNotifications: Notification[] = [];
  seenNotifications: Notification[] = [];
  errors: Notification[] = [];

  page: PaginationPage = {
    pageNumber: 0,
    pageSize: 10
  } as PaginationPage;

  subsciptions: Subscription[] = [];

  constructor(
    private _dataService: DataService,
    private _backEndService: BackEndService,
    private _dialogRef: MatDialogRef<NotificationDialogComponent>
  ) {
    this.unseenNotifications = this._dataService.notifications.filter(x => !x.notificationseen);
    this.aggregateNumber();
    this.setErrorNotifications();
    this.subsciptions.push(this._backEndService.sessionErrorsAnchor.subscribe(() => this.setErrorNotifications()));
  }

  aggregateNumber(){
    this.total = this.unseenNotifications.length;
  }

  close(){
    this._dialogRef.close();
  }

  loadMoreEntries(){
    this.page.pageNumber++;
    this._backEndService.post("api/notification/pagination", this.page).subscribe((result: PaginationResponse<Notification[]>) => {
      for(let notification of result.content) this.seenNotifications.push(notification);
    });
  }

  ngOnDestroy(){
    for(let sub of this.subsciptions){
      sub.unsubscribe();
    }
    this.subsciptions = [];
  }

  ngOnInit(): void {
  }

  notificationSelected(notification: Notification){
    if(notification){
      this._dialogRef.close(notification);
    }
  }

  setErrorNotifications(){
    this.errors = this._backEndService.sessionErrors.sort((a, b) => {
      let aUx = moment(a.notificationtime).unix();
      let bUx = moment(b.notificationtime).unix();
      return aUx >= bUx? -1: 1;
    });
  }

}
